import { cva } from "class-variance-authority";

/**
 * Batch C — touch targets: default/icon ≥ 44×44 CSS px (#7).
 * `sm` stays denser (h-9) for desktop-dense secondary controls only — avoid as
 * primary mobile tap actions (#24 install / primary CTAs should use default).
 */
const primary = "bg-amber-500 text-slate-950 hover:bg-amber-400";
const secondary =
  "border border-slate-200 bg-white hover:bg-slate-50 text-slate-900 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50 dark:hover:bg-slate-900";
const danger = "bg-red-600 text-white hover:bg-red-500";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ring-offset-white dark:ring-offset-slate-950",
  {
    variants: {
      variant: {
        default:
          "bg-slate-900 text-white hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200",
        /** Primary CTA. `accent` is the same classes, kept for existing call sites. */
        primary,
        accent: primary,
        /** Secondary. `outline` is the same classes. */
        secondary,
        outline: secondary,
        ghost: "hover:bg-slate-100 text-slate-900 dark:text-slate-50 dark:hover:bg-slate-900",
        /** Danger. `destructive` is the same classes. */
        danger,
        destructive: danger
      },
      size: {
        sm: "h-9 min-h-9 px-3",
        default: "h-11 min-h-[44px] px-4",
        lg: "h-12 min-h-[48px] px-6",
        icon: "h-11 w-11 min-h-[44px] min-w-[44px]"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
